import { Table } from "reactstrap";
import { H6 } from "../../../AbstractElements";
import { useTranslation } from "react-i18next";

const ViewGeneralSection = ({orgData}:any) => {
  console.log(orgData,"orgData of the lanuage");
  const {t}=useTranslation()
  
  return (
    <td>
      <Table className="bill-content w-100">
        <tbody>
        <tr>
            <td style={{ width: "21%" }}>
              <span style={{ opacity: "0.8",color:"#757272" }}>{t("OrganizationTimezone")}</span>
              <H6 style={{ width: "46%" }}>
                {orgData?.timezone? orgData?.timezone : "UTC+1"} 
              </H6>
            </td>
            <td style={{ width: "21%" }}>
              <span style={{ opacity: "0.8",color:"#757272" }}>{t("OrganizationCurrency")}</span>
              <H6>{orgData.currency? orgData.currency : "N/A"}</H6>
            </td>
            <td>
              <span style={{ opacity: "0.8",color:"#757272" }}>{t("PageLimit")}</span>
              <H6>{orgData.pageLimit? orgData.pageLimit : "10"}</H6>
            </td>
            <td >
              <span style={{ opacity: "0.8",color:"#757272" }}>{t("DateFormat")}</span>
              <H6>{orgData.dateFormat? orgData.dateFormat : "DD-MM-YYYY"}</H6>
            </td>
            <td>
              <span style={{ opacity: "0.8",color:"#757272" }}>{t("Language")}</span>
              <H6>{orgData.languages? orgData.languages.join(", ") : "English"}</H6>
            </td>
           
          </tr>
          <tr>
         
          </tr>
        
        </tbody>
      </Table>
    </td>
  );
};

export default ViewGeneralSection;
